import { useList } from '../../list';

type Props = { params: any };

export function useListDepartments({ params = {} }: Props) {
  const { data, isLoading, refetch, isFetching, isRefetching } = useList(
    'department/select',
    { ...params },
    {},
    'v1',
  );

  return {
    data: data?.data?.data,
    isLoading: isLoading || isFetching || isRefetching,
    refetch,
  };
}
